<template>
  <el-dialog ref="dialog" :visible="visible" @close="$emit('update:visible', false)" :before-close="beforeClose" class="dialog-w40">
    <h2 class="text-center mt-0">Вы действительно хотите удалить выделенные заказы?</h2>

    <div class="text-center text-secondary mt-2">Действие не может быть отменено</div>

    <div class="row mt-4">
      <div class="col-12">
        <el-table size="small" :data="items" max-height="100%" border>
          <el-table-column prop="number" label="Номер заказа" min-width="140" />
          <el-table-column prop="status.title" label="Статус заказа" min-width="160"/>
          <el-table-column prop="includeAttachedFiles" label="Наличие вложений" min-width="140">
            <template slot-scope="scope">
              {{scope.row.includeAttachedFiles ? 'Да': 'Нет'}}
            </template>
          </el-table-column>
          <el-table-column label="" width="42">
            <template slot-scope="scope">
              <i class="el-icon-close font-weight-bold pointer" @click="onDeleteFromTable(scope.row.id)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 col-lg-6 mx-auto mb-3 mb-lg-0">
        <el-button class="w-100" @click="onCancel" :disabled="deleteProgress">Отменить</el-button>
      </div>
      <div class="col-12 col-lg-6 mx-auto">
        <el-button class="w-100" type="danger" @click="onApply" :loading="deleteProgress">Удалить</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    visible: Boolean,
    items: Array,
  },
  computed: {
    ...mapGetters({
      deleteProgress: 'orders/deleteProgress',
    }),
  },
  methods: {
    ...mapActions({
      deleteOrders: 'orders/deleteOrders',
    }),
    beforeClose(done) {
      if (!this.deleteProgress) {
        done();
      }
    },

    onDeleteFromTable(id) {
      this.$emit('deleteId', id);
    },

    onCancel() {
      this.$emit('update:visible', false);
    },
    onApply() {
      this.onSubmit();
    },

    onSubmit() {
      this.deleteOrders({ orders: this.items })
        .then(() => {
          this.$emit('update:visible', false);
        });
    },
  },
  watch: {
    items(newVal) {
      if (!newVal.length) {
        this.$emit('update:visible', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-close {
  font-size: 20px;
}
</style>
